var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: [_vm.$style.topLevelNavigation, _vm.$style.swapClientTypeButton],
      attrs: { "data-automation": "loginSwapClient" },
      on: { click: _vm.clickHandler },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "svg",
        {
          class: _vm.$style.swapClientTypeIcon,
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 16 16",
            "svg-inline": "",
            role: "presentation",
            focusable: "false",
            tabindex: "-1",
          },
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              d: "M10.96 9.715H0V7.116h11.091L6.812 2.838 8.65 1l6.431 6.432.919.918-.919.919-6.431 6.432-1.838-1.838z",
            },
          }),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }